const Collection = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="3" width="24" height="22" rx="4" fill="#BB98F7" />
      <rect x="1" y="6" width="30" height="22" rx="4" fill="#8646F2" />
      <path
        d="M18.5893 12H13.6339C12.7589 12 12.0357 12.8194 12.0357 13.8389L12 21.023C12 21.3756 12.1875 21.6995 12.5 21.871C12.6518 21.9568 12.8125 21.9949 12.9732 21.9949C13.1518 21.9949 13.3304 21.9472 13.4911 21.8424L16 20.2322L18.5089 21.8424C18.8214 22.0425 19.1875 22.052 19.5089 21.871C19.8214 21.6995 20 21.3756 20 21.023V13.8389C20 12.8861 19.3839 12.0953 18.5714 12H18.5893Z"
        fill="white"
      />
    </svg>
  );
};

export default Collection;
